import { PripomienkovanieConfigApi, Vyjadrenia } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import dateToString from '../../function/dateToString';

const client = new PripomienkovanieConfigApi(apiConfiguration(elegislativaPrefixPath));

const map = (
  durationDays: number,
  startDate: Date,
): Vyjadrenia => ({
  durationDays: durationDays || 0,
  startDate: startDate ? dateToString(startDate) : null,
});

// eslint-disable-next-line import/prefer-default-export
export const changeVyjadrenia = async (
  type: string,
  year: number,
  index: number,
  durationDays: number,
  startDate: Date,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const vyjadrenia = map(durationDays, startDate);
  const { status } = await client.changeVyjadrenia(type, year, index, vyjadrenia, headers);
  return {
    responseCode: status,
  };
};
